import { onNextPageTeardown } from '@app/adapters/page-teardown'

import setupWidgets from './widgets'

onDomLoad(function ($dom) {
  const exportForm = $dom.find('[data-behaviour="export-form"]')

  if (exportForm.length) {
    const unsubscriber = setupWidgets()

    onNextPageTeardown(unsubscriber)
  }
})
